import {Aggregation} from '@/__generated__/__types__';
import React from 'react';

interface FilterByAggregationProps {
    aggregationList: Aggregation[];
    renderAggregationItem: (aggregation: Aggregation) => React.ReactElement;
}

const FilterByAggregation: React.FC<FilterByAggregationProps> = ({aggregationList, renderAggregationItem}) => {
    if (!aggregationList.length) {
        return <></>;
    }

    return (
        <>
            {aggregationList.map(aggregation => (
                <>{renderAggregationItem(aggregation)}</>
            ))}
        </>
    );
};

export default FilterByAggregation;
